import { FC } from "react"
import { Activity, LoanOfficer } from "../../../../types"
import { convertActivityToString } from "../../../utils"
import If from "../../if"

interface Props {
  activity: Activity
  member: LoanOfficer
  isLoActivity?: boolean
}

const ActivityCard: FC<Props> = ({ activity, member, isLoActivity }) => {
  return (
    <div className="flex items-center justify-betwee py-4">
      <If
        condition={!!isLoActivity}
        then={
          <>
            <div className="max-w-[10rem] h-6 flex items-center rounded-full overflow-hidden mr-4">
              <img
                src={member.picture}
                alt={member.name}
                className="w-auto h-full object-contain"
              />
            </div>
            <div className="flex-1 whitespace-break-spaces">
              {convertActivityToString(activity, member)}
            </div>
          </>
        }
        else={
          <>
            <div className="max-w-[10rem] h-6 flex items-center rounded-full overflow-hidden mr-4">
              <img
                src={member.logo}
                alt={member.name}
                className="w-auto h-full object-contain"
              />
            </div>
            <div className="flex-1 whitespace-break-spaces">
              {convertActivityToString(activity, member)}
            </div>
          </>
        }
      />
    </div>
  )
}

export default ActivityCard
